import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-form-acj-view',
  templateUrl: './form-acj-view.component.html',
  styleUrls: ['./form-acj-view.component.scss']
})
export class FormAcjViewComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
